module.exports = __webpack_public_path__ + "static/media/simulation-select-percent-icon.898fd29d.svg";